export default __webpack_public_path__ + "static/media/pag35.9c452318.jpg";